var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tiy7x8ikea",
    d: "M9.36 5.544c-.184 0-.369-.068-.51-.203L5.04 1.673 1.23 5.341c-.282.27-.737.27-1.019 0-.281-.271-.281-.71 0-.98L4.531.203c.281-.27.737-.27 1.018 0l4.32 4.158c.281.27.281.709 0 .98-.14.135-.325.203-.51.203"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-873.000000, -550.000000) translate(301.000000, 324.000000) translate(170.000000, 160.000000) translate(254.000000, 41.000000) translate(148.000000, 25.000000) translate(6.360000, 6.228000) rotate(180.000000) translate(-6.360000, -6.228000) translate(1.320000, 3.456000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "whs165qfkb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tiy7x8ikea"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#020303",
    xlinkHref: "#tiy7x8ikea"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#whs165qfkb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M0 0H23.184V21.672H0z",
    transform: "translate(-6.552000, -8.568000)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown1);
export default __webpack_public_path__ + "static/media/ChevronDown1.6760bdad8929b8b715e510e4543789d2.svg";
export { ForwardRef as ReactComponent };